import React from 'react';

/**
 * Icon Atom Component
 * A simple icon component using Bootstrap icons or emoji fallbacks
 */
const Icon = ({ 
  name,
  emoji,
  size = '1rem',
  color,
  className = '',
  ...props 
}) => {
  const style = {
    fontSize: size,
    color: color,
    display: 'inline-block'
  };

  // If emoji is provided, use that
  if (emoji) {
    return (
      <span 
        className={`icon-emoji ${className}`} 
        style={style}
        {...props}
      >
        {emoji}
      </span>
    );
  }

  // Bootstrap icons (if available) or fallback
  return (
    <i 
      className={`bi bi-${name} ${className}`}
      style={style}
      {...props}
    ></i>
  );
};

export default Icon;
